import React from 'react'

export interface UnfinishedJobInfo {
  id: string
  job_number: string
  title: string
}

interface UnfinishedJobClockOutModalProps {
  open: boolean
  job: UnfinishedJobInfo | null
  busy?: boolean
  onCancel: () => void
  onGoFinish: () => void
  onLeaveUnfinished: () => void | Promise<void>
}

function jobLabel(job: UnfinishedJobInfo): string {
  const num = job.job_number
    ? job.job_number.match(/^JOB-/i)
      ? job.job_number
      : `JOB-${job.job_number}`
    : null
  if (num && job.title) return `${num} (${job.title})`
  return num || job.title || 'your current job'
}

export function UnfinishedJobClockOutModal({
  open,
  job,
  busy,
  onCancel,
  onGoFinish,
  onLeaveUnfinished,
}: UnfinishedJobClockOutModalProps) {
  if (!open || !job) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
      <div className="bg-white rounded-xl shadow-xl max-w-md w-full p-5 space-y-4">
        <h3 className="text-lg font-semibold text-gray-900">Job still in progress</h3>
        <p className="text-sm text-gray-600">
          You still have {jobLabel(job)} in progress. Did you finish it?
        </p>
        <div className="flex flex-col gap-2">
          <button
            type="button"
            disabled={busy}
            onClick={onGoFinish}
            className="w-full px-4 py-2.5 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 disabled:opacity-50"
          >
            Go finish it
          </button>
          <button
            type="button"
            disabled={busy}
            onClick={() => void onLeaveUnfinished()}
            className="w-full px-4 py-2.5 bg-amber-600 text-white rounded-lg text-sm font-medium hover:bg-amber-700 disabled:opacity-50"
          >
            Leave unfinished &amp; clock out
          </button>
          <button
            type="button"
            disabled={busy}
            onClick={onCancel}
            className="w-full px-4 py-2.5 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  )
}
